export const MERCHANT_INVENTORY_SETTINGS = {
    MERCHANT_INVENTORY_SETTINGS_LINK: "merchant_inventory_settings",
    ADD_NEW_EMPTY_ASSIGNMENT: "add_new_empty_assignment",
    SAVE: "save",
};
